import { makeAutoObservable } from 'mobx'

type IGroupStreamType = 'default' | 'twilio'

class ManagerStream {
  private _groupStreamMap: Map<IGroupStreamType, Map<MediaStream['id'], MediaStream>> = new Map()

  constructor() {
    makeAutoObservable(this)
  }

  get streamDefault() {
    const defaultGroup = this._groupStreamMap.get('default')

    if (!defaultGroup) return null

    const stream: MediaStream | undefined = Array.from(defaultGroup.values())?.find(
      (item) => item.active
    )

    if (!stream) return null

    return stream
  }

  stopTrack = (stream: MediaStream) => {
    stream.getAudioTracks().forEach((track) => {
      track.stop()
    })
    stream.getVideoTracks().forEach((track) => {
      track.stop()
    })
  }

  stopTracks = (type: IGroupStreamType) => {
    this._groupStreamMap.get(type)?.forEach((stream) => {
      this.stopTrack(stream)
    })
  }

  removeStreams = (type: IGroupStreamType) => {
    this.stopTracks(type)
    this._groupStreamMap.get(type)?.clear()
  }

  addStream = (type: IGroupStreamType, item: MediaStream) => {
    this.removeStreams(type)

    const group = this._groupStreamMap.get(type)

    if (group) {
      group.set(item.id, item)
    } else {
      const map = new Map()

      map.set(item.id, item)

      this._groupStreamMap.set(type, map)
    }
  }
}

export const managerStream = new ManagerStream()
